import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["searchInput"]
  static values = {
    searchEvent: String
  }

  dispatchSearchEvent() {
    const event = new CustomEvent(this.searchEventValue, { detail: { search_query: this.searchInputTarget.value } })

    window.dispatchEvent(event)
  }
}
